export default "__VITE_ASSET__v$K7QT2v__"